module.exports = __webpack_public_path__ + "static/media/trustedmalaysia.3eaf3ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trustedmalaysia.png
// module id = 548
// module chunks = 0